import {SMALL_DEVICE_MEDIA_SIZE} from "components/common/constants";

export const adminStyles = theme => ({
    root: {
        
        
        [theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE)]: {
            paddingRight:"0 !important",
            paddingLeft:"0 !important"
        }
        
    },
    paperMenu: {
        marginRight: theme.spacing(2),
    },
    menuItemSelected: {
        color:theme.palette.secondary.main,
        borderRight: "1px solid " +  theme.palette.secondary.main,
        borderLeft: "1px solid " +  theme.palette.secondary.main
    },
    formFixed: {
        position:"fixed",
        right: 0,
        top: 70,
        [theme.breakpoints.down("md")]: {
            right:"initial",
            position:"relative",
            top:"initial"
        }
    }
}
);